// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__XyMZe","head":"index_head__dggbx","filter":"index_filter__QzOiU","chartWrapper":"index_chartWrapper__fiv0e"};